import { render, staticRenderFns } from "./SpecialOpeningHoursChange.vue?vue&type=template&id=0a445ffc&scoped=true&"
import script from "./SpecialOpeningHoursChange.vue?vue&type=script&lang=js&"
export * from "./SpecialOpeningHoursChange.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOpeningHoursChange.vue?vue&type=style&index=0&id=0a445ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a445ffc",
  null
  
)

export default component.exports